<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e2353"><b>DEDICATED TO </b></p>
<p class="ser"><img alt="RevelationRevealed_0003_001" id="d14e93" src="images/RevelationRevealed_0003_001.jpg" style="max-width:100%;"/></p><p class="h2" id="d7e2423"><span class="small">DR. DAVID D. ALLEN, </span></p>
<p class="tx2" id="d7e2473">who, upon my conversion to Christianity, opened my mind, eyes, and heart to prophetical truth as a professor at Detroit Bible College (now William Tyndale College), . . . and to </p>
<p class="h2" id="d7e2613"><span class="small">GREG HARRELL, </span></p>
<p class="extc" id="d7e2703">whose expertise as a writer was tremendously helpful<br/> in editing this work, and to </p>
<p class="h2" id="d7e2783"><span class="small">REBECCA (SHELTON) KILGUS, </span></p>
<p class="extc" id="d7e2863">my niece, whose untiring efforts in preparing the final manuscript are deeply appreciated.</p>
<p class="extc" id="d7e2983s"><br/><br/></p>
<p class="extc" id="d7e2983">—Dr. Jack Van Impe </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Impe_ISBN9781418517243_epub_c3_r1.vue?dbd4dd9a